import BaseModel from '../core/BaseModel'
export default class RequestReturnProductProcessModel extends BaseModel {
    constructor() {
        super({ 
                name: "request_return_product_process",
                tableName: 'core_request_return_product_process'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            modified_date: { 
                name: 'modified_date', 
                type: "CustomDateTime", 
                label: 'Thời gian cập nhật',
                class: 'top-datepicker',
                width: 13,
                filter: { type: 'DateRange', match: 'custom'}
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Người cập nhật',
                class: 'center',
                width: 13,
                computed: (data) => {
                    data.full_name = (data.users != undefined && data.users != null) ? data.users.full_name : '';
                }
            },
            organization_name: { 
                name: 'organization_name', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                type: "String",
                width: 15,
                computed: (data) => {
                    var organization = (data.users != undefined && data.users != null && data.users.organization_account != undefined && data.users.organization_account != null) ? data.users.organization_account : null;
                    if (organization != null) {
                        data.organization_name = (organization.organization != undefined && organization.organization != null ) ? organization.organization.name : '';
                    }
                }
            },
            note: { 
                name: 'note', 
                label: 'Nội dung',
                width: 25,
            },
            return_status: { 
                name: 'return_status', 
                type: "Selection",
                label: 'Trạng thái thẩm định',
                dataType: 'Label',
                class: 'center',
                width: 13,
                filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                options: [{ value: 0, label: 'Đang yêu cầu'}, { value: 1, label: 'Chờ thẩm định'}, { value: 2, label: 'Hủy yêu cầu'}, { value: 3, label: 'Tự động duyệt'}, { value: 4, label: 'Không duyệt'}, { value: 5, label: 'Đã duyệt'}, { value: 6, label: 'Chờ gửi yêu cầu'}],
            },
            warrantyStatus: { 
                name: 'warrantyStatus', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label',
                class: 'center',
                width: 13,
                filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                options: [{ value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, { value: 5, label: 'Tắt kích hoạt'}, { value: 6, label: 'Sản phẩm huỷ'}],
                computed: (data) => {
                    // data.warrantyStatus =  data.warranty_status == 5 ? 0 : data.warranty_status;
                    data.warrantyStatus =  data.warranty_status;
                }
            },
            user_id: {
                refs: 'request_return_product_id warranty_status users {full_name organization_account { organization { name } } }',
                display: false
            }
        },)
    }

}